






import {Component, Vue} from "vue-property-decorator";
//@ts-ignore
import components from "aws-amplify-vue";
import {Amplify} from "aws-amplify";

@Component({
    components: {
        ...components
    }
})
export default class Login extends Vue {
    private authConfig = {
        signInConfig: {isSignUpDisplayed: false},
    };
    private showSignOut = false;

    mounted() {
        Amplify.Auth.currentSession().then((data: any) => {
            this.showSignOut = data.isValid()
        }).catch(() => {
            this.showSignOut = false;
        });
    }
}
